import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable } from 'aurelia-framework';
import { PenPipeSDRDto } from 'models/pen/PenPipeSDR';

@autoinject
export class PenPipeSdrForm {
  @bindable
  private penPipeSdr: PenPipeSDRDto;
  protected isDuplicate = false;

  constructor(private eventAggregator: EventAggregator) {}

  private attached() {
    this.eventAggregator.subscribe('penPipeSDRIsDuplicate', (isDuplicate) => {
      this.isDuplicate = isDuplicate;
    });
  }
}
